module.exports = __webpack_public_path__ + "img/MES9Indice4.cf4c18ab.png";